import { observer } from "mobx-react-lite";
import { FC } from "react";
import styled from "@emotion/styled";
import { OAuthCardWrapper } from "@/pages/oauth-consent/oauth-card-wrapper";

export interface OAuthCardErrorProps {}

export const OAuthCardError: FC<OAuthCardErrorProps> = observer(() => {
  return (
    <OAuthCardWrapper>
      <TitleSection>Something went wrong.</TitleSection>
    </OAuthCardWrapper>
  );
});

const TitleSection = styled.div`
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: ${({ theme }) => theme.fontSizes["header-m"]};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  letter-spacing: ${({ theme }) => theme.lineSpacings["header-l"]};
  margin-bottom: 28px;
`;
